import { valToPercent } from '../../../helpers/value'

export const getPercentDiscount = ({ price = 0, dataBlocks = [] }, locale) => {
  const sum = dataBlocks.reduce(
    (partialSum, current) => partialSum + current.price,
    0,
  )

  return valToPercent(
    sum === 0 ? 0 : (sum - price) / sum,
    locale,
    false,
    false,
    0,
  )
}
